import { DatePipe } from '@angular/common';
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { CommonService } from '../../Services/common.service';
import { ConfigSettingService } from '../../Services/config-setting.service';
import { DataManipService } from '../../Services/data-manip.service';
import { EncrptDecreptService } from '../../Services/encrpt-decrept.service';

@Component({
  selector: 'app-download-test-modal',
  templateUrl: './download-test-modal.component.html',
  styleUrls: ['./download-test-modal.component.scss']
})
export class DownloadTestModalComponent implements OnInit {

  @ViewChild('printPdfPopup', { static: false }) public printPdfPopup: ModalDirective;



  @Input() userid: number = null;
  @Input() openFromAdminSide: boolean;
  @Input() username: string = "";

  popupheading: string = ""
  errorMsg: string = "";

  showGtPlusTbl: boolean = false;
  tableconfig = {};
  tableheaders = [];
  tabledata = [];
  dataLocalUrl: any;
  pdfName: string = "";

  constructor(private encryptService : EncrptDecreptService, private configSetting: ConfigSettingService, private domSanitizer: DomSanitizer, private ngbActiveModal: NgbActiveModal, private datePipe: DatePipe, private commonServices: CommonService, public dataManipSrvc: DataManipService) { }

  ngOnInit(): void {
    console.log(this.username);

    this.getAllTests();
    if (this.openFromAdminSide) {
      this.popupheading = "Users Test"
    } else {
      this.popupheading = "My Tests"
    }
  }

  getAllTests() {
    let apiUrl = this.configSetting.getBaseUrl() + "user/getuserCompletedTestList";
    let body = {   "updi": this.encryptService.encrypt(this.userid+"")  }

    this.commonServices.getWithParams(apiUrl, body).subscribe(successResp => {
      this.showGtPlusTbl = true;
      if (successResp['errorCode'] == "000000") {
        this.tableheaders = successResp["Data"]["tableheaders"];
        this.tableconfig = successResp["Data"]["tableconfig"];
        this.tabledata = successResp["Data"]["tabledata"];

        this.tableconfig['actioncolmconfig']['print'] = true;
        this.tableconfig['customactionbuttons'][0]['class'] = 'btn-primary';
        this.tableheaders.forEach((item) => {
          if (item['key'] == 'testcompletedon') {
            item['editable'] = false;
          }
        })

      } else if (successResp['errorCode'] == 111000) {
        this.errorMsg = successResp['errorDescription'];
      }
    }, (err) => {
//      console.log(err);
    })
  }

  downloadReport(event: any, operation: string) {
    let params =
    {
      "userid": this.encryptService.encrypt(this.userid+""),
      "testid": this.encryptService.encrypt(event["row"]["testid"]+""),
      "usertestid": this.encryptService.encrypt(event["row"]["usertestid"]+"")
    };
    let apiUrl = this.configSetting.getBaseUrl() + "dashtest/downloadResultPDF";
    this.commonServices.downloadReport(apiUrl, params).subscribe((successResp: any) => {

      let blob = new Blob([successResp], { type: 'application/pdf' });
//      console.log(blob);

      let url = window.URL.createObjectURL(blob);

      let testDate = this.datePipe.transform(event["row"]["testcompletedon"], "dd-MMM-yyyy_HH:MM");
      if (operation == 'download') {
        let a = document.createElement('a');
        document.body.appendChild(a);
        a.setAttribute('style', 'display: none');
        a.href = url;
        a.download = event["row"]["testname"] + "_" + event["row"]["usertestid"] + "_" + testDate;
        a.click();
        window.URL.revokeObjectURL(url);
        a.remove();
      } else if (operation == 'print') {
        // this.pdfName = (event["row"]["usertestid"] + "_" + testDate).trim();

        // console.log(url);
        // url = url + '?file=' + this.pdfName;
        // console.log(url);

        // const Pagelink = "about:blank";
        // window.frames

        
        this.dataLocalUrl = this.domSanitizer.bypassSecurityTrustResourceUrl(url);
        this.printPdfPopup.show();


        // let openpdfwindow = window.open(Pagelink, '_blank');

        // let urldata = this.blobToBase64(blob);
        // console.log(urldata);

        // openpdfwindow.document.open();
        // openpdfwindow.document.title = this.pdfName;
        // openpdfwindow.document.write(successResp);
        // openpdfwindow.print();
        // openpdfwindow.close();
        // blob['print()'];

        // // this.dataLocalUrl = this.dataLocalUrl + '#' + this.pdfName;
        // console.log("dataLocalUrl", this.dataLocalUrl);




        // setTimeout(() => {
        //   // const iframe = document.getElementById('print');
        //   // const ele =  <HTMLElement> iframe.getElementsByTagName('cr-icon-button')[0];
        //   // iframe.click();
        //   // window.frames[0].print();
        //   let objFra =  document.getElementById('iframe-print');
        //   objFra.contents()
        //   // objFra.contentWindow.focus();
        //   // objFra.contentWindow.print();
        // }, 2000);

        // let url:any = {};
        // url = this.domSanitizer.bypassSecurityTrustResourceUrl(url);
        
        // const blobUrl = url;
        // let HTML = `<html>
        //               <head></head>
        //               <body>
        //                 <div id="pdfCntent"></div>
        //               </body>
        //               <script>
        //                 document.getElementById('pdfCntent').load(${blobUrl});
        //           //      console.log("Before settimeout");
        //                 setTimeOut(()=>{
        //           //      console.log("IN settimeout");

        //                   document.getElementById('pdfCntent').print();
        //                 },500)			
        //               </script>
        //           </HTML>`
        // this.dataLocalUrl = HTML;

      }


    },
      err => {
        alert("Problem while downloading the file.");

        console.error(err);
      }
    );
  }

  loadPdf() {
    window.print();
  }

  blobToBase64(blob) {
    return new Promise((resolve, _) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.readAsDataURL(blob);
    });
  }

  downloadtestmodalcloseevt(data = null) {

    this.ngbActiveModal.close();
    // this.router.navigateByUrl('/dashboard');


  }

  getEve(eve) {
    console.log(eve);

  }

}
